import {
  buildAdminListQuery,
  type TAdminListParams,
} from '@/core/lib/table-query'
import type { TQuestionPoolQuestionListParams } from '@/modules/question-pool/question-pool.types'

export const QUESTION_POOL_STATUSES = ['ACTIVE', 'PASSIVE'] as const

export const questionPoolEndpoints = {
  list: (params: TAdminListParams) =>
    `/admin/question-pools?${buildAdminListQuery(params)}`,
  options: '/admin/question-pools/all',
  detail: (id: string) => `/admin/question-pools/${id}`,
  create: '/admin/question-pools',
  edit: (id: string) => `/admin/question-pools/${id}`,
  status: (id: string) => `/admin/question-pools/${id}/status`,
  delete: (id: string, deleteQuestions: boolean) =>
    `/admin/question-pools/${id}?delete_questions=${deleteQuestions}`,
  questions: (id: string) => `/admin/question-pools/${id}/questions`,
  questionList: (params: TQuestionPoolQuestionListParams) => {
    const query = new URLSearchParams(
      buildAdminListQuery({
        ...params,
        searchField: params.searchField ?? 'question',
      })
    )
    if (params.questionPoolId) {
      query.set('question_pool_id', params.questionPoolId)
    }
    if (params.poolState) query.set('pool_state', params.poolState)
    if (params.excludeQuestionPoolId) {
      query.set('exclude_question_pool_id', params.excludeQuestionPoolId)
    }
    return `/admin/questions?${query.toString()}`
  },
}

export const questionPoolQueryKeys = {
  all: ['questionPools'] as const,
  lists: () => [...questionPoolQueryKeys.all, 'list'] as const,
  list: (params: TAdminListParams) =>
    [...questionPoolQueryKeys.lists(), params] as const,
  options: () => [...questionPoolQueryKeys.all, 'options'] as const,
  details: () => [...questionPoolQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...questionPoolQueryKeys.details(), id] as const,
  questions: (id: string, params: TAdminListParams) =>
    [...questionPoolQueryKeys.detail(id), 'questions', params] as const,
  candidates: (id: string, params: TAdminListParams) =>
    [...questionPoolQueryKeys.detail(id), 'candidates', params] as const,
}

export const questionPoolBackendErrors = {
  QUESTION_POOL_NOT_FOUND: 'Soru havuzu bulunamadı!',
  QUESTION_POOL_EXISTS: 'Bu isimde bir soru havuzu zaten mevcut!',
  QUESTION_POOL_INVALID_STATUS: 'Soru havuzu durumu geçersiz!',
  QUESTION_POOL_HAS_QUESTIONS: 'Soru havuzunda bağlı sorular bulunuyor!',
  QUESTION_POOL_PASSIVE:
    'Pasif soru havuzlarına yeni soru eklenemez. Önce havuzu aktif duruma getirin!',
  QUESTION_POOL_MEMBERSHIP_CONFLICT:
    'Seçilen sorulardan bazıları başka bir soru havuzunda!',
  GENERAL_ERROR: 'Beklenemeyen bir hata oluştu!',
}

export const questionPoolSuccessMessages = {
  create: 'Soru havuzu başarıyla oluşturuldu!',
  edit: 'Soru havuzu başarıyla düzenlendi!',
  status: 'Soru havuzu durumu güncellendi!',
  delete: 'Soru havuzu başarıyla silindi!',
  questions: 'Soru havuzu üyelikleri güncellendi!',
}
